import {
  HEL_AUDIO_TYPE_WORLD,
  HEL_AUDIO_TYPE_VOICE,
  HEL_AUDIO_TYPE_SE,
  HEL_AUDIO_TYPE_SYSTEMSE,
  HEL_AUDIO_TYPE_VIDEO,
  HEL_VIDEO_PLAYER_DEFAULT,
  HEL_VIDEO_PLAYER_IVS,
  HEL_VIDEO_PLAYER_HLS,
  ETextParamType_WorldID,
  ETextParamType_RoomID,
  ETextParamType_SpotName,
  ETextParamType_LocationHref,
  ETextParamType_ShowWorldSelect,
  ETextParamType_Logined,
  ETextParamType_CanvasFileName,
  ETextParamType_CurrentUserName,
  ETextParamType_SceneItem,
  ETextParamType_OperateCanvas,
  ETextParamType_ReplaceMyAvatar,
  ETextParamType_PlayVideo,
  ETextParamType_NamePlateTextureFileName0,
  ETextParamType_NamePlateTextureFileName1,
  ETextParamType_NamePlateTextureFileName2,
  ETextParamType_NamePlateMicMuteTextureFileName,
  ETextParamType_NamePlateMicOnTextureFileName,
  ETextParamType_NamePlateMicTalkingTextureFileName,
  ETextParamType_SetMicState,
  ETextParamType_OperateFunctionFlag,
  ETextParamType_CopyVideoFrameToSystem,
  ETextParamType_CancelToCopyVideoFrameToSystem,
  ETextParamType_SetMicTalkingState,
  ETextParamType_WarpPlayer,
  ETextParamType_PlayerMoveEnable,
  ETextParamType_PlayItem,
  ETextParamType_StopItem,
  ETextParamType_ShowItem,
  ETextParamType_HideItem,
  ETextParamType_ReplaceMyAvatarCustom,
  ETextParamType_SceneJson,
  ETextParamType_ScriptCallComponentMethod,
  ETextParamType_AvatarFileName,
  ETextParamType_GUIDebugInput,
  ETextParamType_HeliodorSDKVersion,
  ETextParamType_ReplaceMyAvatarIcon,
  ETextParamType_SetItemFileName,
  ETextParamType_SetFollowCameraDistance,
  ETextParamType_SetFollowCameraRotate,
  ETextParamType_SetFollowCameraHeight,
  ETextParamType_AddFurniture,
  ETextParamType_SetPlayerRotate,
  ETextParamType_PlayEmote,
  ETextParamType_GetAvatarHeight,
  ETextParamType_StopVideo,
  ETextParamType_IsPlayVideo,
  ETextParamType_ReplaceMyAvatarIconCustom,
  ETextParamType_IsLoading,
  ETextParamType_SubSceneItem,
  ETextParamType_SceneOwner,
  ETextParamType_VideoEnded,
  ETextParamType_GlobalFileName,
  ETextParamType_CheckRestriction,
  ETextParamType_ReplaceFilteredAvatar,
  ETextParamType_ClearMyAvatarCustomMotion,
  ETextParamType_CreateMyAvatarCustomMotion,
  ETextParamType_CreateMyAvatarCustomEmotion,
  ETextParamType_CreateMyAvatarCustomObject,
  ETextParamType_SetDateNow,
  ETextParamType_SetCRPMode,
  ETextParamType_SetPlayerPriority,
  ETextParamType_OnStartScreenShare,
  ETextParamType_OnStopScreenShare,
  ETextParamType_OnReceivedStartScreenShare,
  ETextParamType_OnReceivedStopScreenShare,
  ETextParamType_SetVideoRecording,
  ETextParamType_SetRoomURL,
  ETextParamType_IsUseGamePad,
  ETextParamType_ScriptCallCanvasComponentMethod,
  ETextParamType_HomeJson,
  ETextParamType_HomeJsonWithTemplate,
  ETextParamType_SetGenericWindowState,
  ETextParamType_OnChangedMicPermissionState,
  ETextParamType_IsUseMyAvatar,
  ETextParamType_OnPlayScreenShare,
  ETextParamType_CompImageListFileName,
  ETextParamType_SetItemProperty,
  ETextParamType_OnSendTextChat,
  ETextParamType_OnNetCreatedPlayerID,
  ETextParamType_OnNetPosConnected,
  ETextParamType_OnNetVoiceConnected,
  ETextParamType_GetFirstLoadingRate,
  ETextParamType_OnNetPosDisconnected,
  ETextParamType_OnNetVoiceDisconnected,
  ETextParamType_AddPackFile,
  ETextParamType_SetCDNFolderName,
  ETextParamType_OnNetLiveVideoStarted,
  ETextParamType_OnNetLiveVideoEnded,
  ETextParamType_OnNetLiveVideoPlay,
  ETextParamType_OnNetLiveVideoStop,
  ETextParamType_OnNetLiveConfirmPlayVideo,
  ETextParamType_SetWebCamTrackingPoseData,
  ETextParamType_SetWebCamTrackingHandData,
  ETextParamType_OnNetReceivePosJoin,
  ETextParamType_OnNetReceivePosLeave,
  ETextParamType_OnNetReceiveVoiceJoin,
  ETextParamType_OnNetReceiveVoiceLeave,
  ETextParamType_OnNetLiveConnected,
  ETextParamType_OnNetLiveDisconnected,
  ETextParamType_OnNetLiveRemoteJoin,
  ETextParamType_OnNetLiveRemoteLeave,
  ETextParamType_OnNetEstablishmentFail,
  ETextParamType_OnNetConnectionError,
  ETextParamType_OnNetOperationError,
  ETextParamType_IsAvailableWebCamTracking,
  ETextParamType_StartWebCamTracking,
  ETextParamType_StopWebCamTracking,
  ETextParamType_SetFullBodySendingInterval,
  ETextParamType_Supported_TextureCompression_PVRTC,
  ETextParamType_Supported_TextureCompression_ETC2,
  ETextParamType_Supported_TextureCompression_ASTC,
  ETextParamType_Supported_TextureCompression_DXT,
  ETextParamType_SetAvatarType,
  ETextParamType_GetHeliodorSDKMajorVersion,
  ETextParamType_GetHeliodorSDKMinorVersion,
  ETextParamType_WalkTo,
  ETextParamType_SetProjectionMatrix,
  ETextParamType_OnARDetectedImage,
  ETextParamType_OnNetLobbyingUpdate,
  ETextParamType_OnARFoundWayspot,
  ETextParamType_OnCatchError,
  ETextParamType_TransitToNetworkRedicrectURL,
  EBinaryParamType_FullBodyTrackingData,
  EBinaryParamType_Unlink,
  EBinaryParamType_SetGUIImage
} from './logics/const';

import type {ActionType} from './types/notify.js';
import type {getConfig as getConfigType} from '../../HeliportJS/dist/configs/index';
import type * as heliportType from '../../HeliportJS/dist/heliport.js';

type RequiredNonNullable<T> = {
  [P in keyof T]-?: NonNullable<T[P]>;
};
declare global {
  /* eslint-disable no-var -- NOTE: TypeScriptのグローバルスコープ拡張では「var」が必須 */
  /** @remarks NOTE: Safari 14以前 (iOS 14.4以前) では、ベンダー接頭辞付きのみ存在。 */
  var webkitAudioContext: typeof AudioContext | undefined;

  /**
   * @remarks NOTE: heliport.jsのモジュール除外システム (プラグイン構想がなかった頃のもの) により、
   * 型としては `heliport.v3.api` 配下のプロパティは `undefined` になる可能性があるが、
   * これを強制的に除外している。
   * @see https://discord.com/channels/596169759045976094/974194168484216862/1251041072176693288
   */
  var heliport: {
    v3: Omit<typeof heliportType.v3, 'api'> & {
      api: RequiredNonNullable<typeof heliportType.v3.api>;
    };
  };
  var getConfig: typeof getConfigType;
  /* eslint-enable */
}

Object.assign(
  globalThis,
  {
    NOTIFICATION_ACTION_TYPE_ACHIEVEMENT: 'Achievement',
    NOTIFICATION_ACTION_TYPE_SIMPLE: 'SimpleNotify',
    NOTIFICATION_ACTION_TYPE_ITEM: 'ItemProperty',
    NOTIFICATION_ACTION_TYPE_DISCONNECT: 'Disconnect',
    NOTIFICATION_ACTION_TYPE_TOAST: 'ToastMessage',
    NOTIFICATION_ACTION_TYPE_SYSTEM: 'SystemMessage'
  } satisfies Record<string, ActionType>,
  {
    HEL_AUDIO_TYPE_WORLD,
    HEL_AUDIO_TYPE_VOICE,
    HEL_AUDIO_TYPE_SE,
    HEL_AUDIO_TYPE_SYSTEMSE,
    HEL_AUDIO_TYPE_VIDEO,

    HEL_VIDEO_PLAYER_DEFAULT,
    HEL_VIDEO_PLAYER_IVS,
    HEL_VIDEO_PLAYER_HLS,

    ETextParamType_WorldID,
    ETextParamType_RoomID,
    ETextParamType_SpotName,
    ETextParamType_LocationHref,
    ETextParamType_ShowWorldSelect,
    ETextParamType_Logined,
    ETextParamType_CanvasFileName,
    ETextParamType_CurrentUserName,
    ETextParamType_SceneItem,
    ETextParamType_OperateCanvas,
    ETextParamType_ReplaceMyAvatar,
    ETextParamType_PlayVideo,
    ETextParamType_NamePlateTextureFileName0,
    ETextParamType_NamePlateTextureFileName1,
    ETextParamType_NamePlateTextureFileName2,
    ETextParamType_NamePlateMicMuteTextureFileName,
    ETextParamType_NamePlateMicOnTextureFileName,
    ETextParamType_NamePlateMicTalkingTextureFileName,
    ETextParamType_SetMicState,
    ETextParamType_OperateFunctionFlag,
    ETextParamType_CopyVideoFrameToSystem,
    ETextParamType_CancelToCopyVideoFrameToSystem,
    ETextParamType_SetMicTalkingState,
    ETextParamType_WarpPlayer,
    ETextParamType_PlayerMoveEnable,
    ETextParamType_PlayItem,
    ETextParamType_StopItem,
    ETextParamType_ShowItem,
    ETextParamType_HideItem,
    ETextParamType_ReplaceMyAvatarCustom,
    ETextParamType_SceneJson,
    ETextParamType_ScriptCallComponentMethod,
    ETextParamType_AvatarFileName,
    ETextParamType_GUIDebugInput,
    ETextParamType_HeliodorSDKVersion,
    ETextParamType_ReplaceMyAvatarIcon,
    ETextParamType_SetItemFileName,
    ETextParamType_SetFollowCameraDistance,
    ETextParamType_SetFollowCameraRotate,
    ETextParamType_SetFollowCameraHeight,
    ETextParamType_AddFurniture,
    ETextParamType_SetPlayerRotate,
    ETextParamType_PlayEmote,
    ETextParamType_GetAvatarHeight,
    ETextParamType_StopVideo,
    ETextParamType_IsPlayVideo,
    ETextParamType_ReplaceMyAvatarIconCustom,
    ETextParamType_IsLoading,
    ETextParamType_SubSceneItem,
    ETextParamType_SceneOwner,
    ETextParamType_VideoEnded,
    ETextParamType_GlobalFileName,
    ETextParamType_CheckRestriction,
    ETextParamType_ReplaceFilteredAvatar,
    ETextParamType_ClearMyAvatarCustomMotion,
    ETextParamType_CreateMyAvatarCustomMotion,
    ETextParamType_CreateMyAvatarCustomEmotion,
    ETextParamType_CreateMyAvatarCustomObject,
    ETextParamType_SetDateNow,
    ETextParamType_SetCRPMode,
    ETextParamType_SetPlayerPriority,
    ETextParamType_OnStartScreenShare,
    ETextParamType_OnStopScreenShare,
    ETextParamType_OnReceivedStartScreenShare,
    ETextParamType_OnReceivedStopScreenShare,
    ETextParamType_SetVideoRecording,
    ETextParamType_SetRoomURL,
    ETextParamType_IsUseGamePad,
    ETextParamType_ScriptCallCanvasComponentMethod,
    ETextParamType_HomeJson,
    ETextParamType_HomeJsonWithTemplate,
    ETextParamType_SetGenericWindowState,
    ETextParamType_OnChangedMicPermissionState,
    ETextParamType_IsUseMyAvatar,
    ETextParamType_OnPlayScreenShare,
    ETextParamType_CompImageListFileName,
    ETextParamType_SetItemProperty,
    ETextParamType_OnSendTextChat,
    ETextParamType_OnNetCreatedPlayerID,
    ETextParamType_OnNetPosConnected,
    ETextParamType_OnNetVoiceConnected,
    ETextParamType_GetFirstLoadingRate,
    ETextParamType_OnNetPosDisconnected,
    ETextParamType_OnNetVoiceDisconnected,
    ETextParamType_AddPackFile,
    ETextParamType_SetCDNFolderName,
    ETextParamType_OnNetLiveVideoStarted,
    ETextParamType_OnNetLiveVideoEnded,
    ETextParamType_OnNetLiveVideoPlay,
    ETextParamType_OnNetLiveVideoStop,
    ETextParamType_OnNetLiveConfirmPlayVideo,
    ETextParamType_SetWebCamTrackingPoseData,
    ETextParamType_SetWebCamTrackingHandData,
    ETextParamType_OnNetReceivePosJoin,
    ETextParamType_OnNetReceivePosLeave,
    ETextParamType_OnNetReceiveVoiceJoin,
    ETextParamType_OnNetReceiveVoiceLeave,
    ETextParamType_OnNetLiveConnected,
    ETextParamType_OnNetLiveDisconnected,
    ETextParamType_OnNetLiveRemoteJoin,
    ETextParamType_OnNetLiveRemoteLeave,
    ETextParamType_OnNetEstablishmentFail,
    ETextParamType_OnNetConnectionError,
    ETextParamType_OnNetOperationError,
    ETextParamType_IsAvailableWebCamTracking,
    ETextParamType_StartWebCamTracking,
    ETextParamType_StopWebCamTracking,
    ETextParamType_SetFullBodySendingInterval,
    ETextParamType_Supported_TextureCompression_PVRTC,
    ETextParamType_Supported_TextureCompression_ETC2,
    ETextParamType_Supported_TextureCompression_ASTC,
    ETextParamType_Supported_TextureCompression_DXT,
    ETextParamType_SetAvatarType,
    ETextParamType_GetHeliodorSDKMajorVersion,
    ETextParamType_GetHeliodorSDKMinorVersion,
    ETextParamType_WalkTo,
    ETextParamType_SetProjectionMatrix,
    ETextParamType_OnARDetectedImage,
    ETextParamType_OnNetLobbyingUpdate,
    ETextParamType_OnARFoundWayspot,
    ETextParamType_OnCatchError,
    ETextParamType_TransitToNetworkRedicrectURL,
    EBinaryParamType_FullBodyTrackingData,
    EBinaryParamType_Unlink,
    EBinaryParamType_SetGUIImage
  }
);
